import { render, staticRenderFns } from "./RecoverCode.vue?vue&type=template&id=47de2f85&scoped=true"
import script from "./RecoverCode.vue?vue&type=script&lang=ts"
export * from "./RecoverCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de2f85",
  null
  
)

export default component.exports